import {Component} from '@angular/core';
import {BaseFieldType} from 'compob2b-libs';

@Component({
  selector: 'app-colorpicker',
  templateUrl: './color-picker.component.html'
})
export class ColorPickerComponent extends BaseFieldType {

  changeColor(event): void {
    this.field.model.color = event;
  }

}
